<template>
    <div class="modal fade" data-backdrop="static" data-keyboard="false"  id="approve_modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row px-4 justify-content-end">
                        <button type="button" @click="hideModal" class="btn btn-sm btn-circle btn-icon bg-white">
                            <i class="fa fa-times "></i>
                        </button>
                    </div>
                    <div v-if="two_factor_type === TwoFactorType.GOOGLE_AUTHENTICATOR" class="row pr-4 pb-4 w-100">
                        <label for="google_authenticator_code">{{$t('auth.login.google_authenticator_code')}}</label>
                        <kt-form-control
                        v-bind:placeholder="$t('auth.login.google_authenticator_code')"
                            name="google_authenticator_code"
                            class="text-center"
                            autocomplete="off"
                            v-model="data"
                            type="text"
                            id="google_authenticator_code"
                            dir="ltr"
                        />
                        <a v-if="!loading" class="link mt-2 mr-1" @click="changeTwoFactorType(TwoFactorType.SMS)">{{$t('label.send_request_with_sms')}}</a>
                        <button v-else :disabled="loading" class="btn btn-link mt-2 mr-1">{{$t('label.send_request_with_sms')}}</button>
                    </div>
                    <div v-else class="row pr-4 pb-4 w-100">
                        <label for="otp">{{message}}</label>
                        <input v-model="data" type="text" class="form-control">
                        <a v-if="!loading" class="link mt-2 mr-1" @click="changeTwoFactorType(TwoFactorType.GOOGLE_AUTHENTICATOR)">{{$t('label.send_request_with_google')}}</a>
                        <button v-else :disabled="loading" class="btn btn-link mt-2 mr-1">{{$t('label.send_request_with_google')}}</button>
                    </div>
                    <div class="d-flex px-1 justify-content-end mb-3">
                        <button @click="hideModal()"
                                class="btn btn-danger btn-sm px-5 rounded-pill py-2 ml-2 font-weight-bold"
                                style="font-size: 14px">انصراف
                        </button>
                        <button @click="emitAction(data)" id="approve_button"
                                :disabled="loading"
                                class="btn btn-primary btn-sm rounded-pill px-5 py-2 mr-2  font-weight-bold"
                                style="font-size: 14px">
                            <span v-if="loading" class="spinner-border"></span>
                            <span v-else>ارسال</span>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import {TwoFactorType} from "@/constants/TwoFactorType";
import Inputmask from "inputmask";

export default {
    name: "Approve",
    computed: {
        TwoFactorType() {
            return TwoFactorType
        }
    },
    props: {
        message: {
            required: true
        },
        two_factor_type: {
            required: false,
            default: TwoFactorType.SMS
        },
        data: {
            required: false,
            default: null
        },
        loading: {
            required: false,
            default: false
        }
    },
    methods: {
        hideModal() {
            $('#approve_modal').modal('hide');
        },
        emitAction(data) {
            this.$emit('emitAction', data.replace(/\s+/g, ''))
        },
        changeTwoFactorType(type) {
            this.data = '';
            this.masked();
            this.two_factor_type = type;
            this.$emit('sendRequest', this.two_factor_type)
        },
        masked() {
            setTimeout(() => {
                document.getElementById("google_authenticator_code") &&
                Inputmask("9     9     9     9     9     9").mask(document.getElementById("google_authenticator_code"));
            }, 100);
        }
    },
    mounted() {
        this.masked()
    },
}
</script>
<style scoped>
    a {
        color: #0f9af0 !important;
        cursor: pointer;
    }

    a:hover{
        border-bottom: 1px solid #0f9af0;
    }
</style>